import { mapActions } from 'vuex'
import { eventBus } from '@/main'

import moment from 'moment'

export default {
    methods: {
        ...mapActions({
            FetchStudentByKeycloakID: 'enterpriseDataApi/FetchStudentByKeycloakID',
            FetchStudentContactDetailsByStudentID: 'enterpriseDataApi/FetchStudentContactDetailsByStudentID',
            FetchCurrentStudentEnrolmentsByStudentID: 'enterpriseDataApi/FetchCurrentStudentEnrolmentsByStudentID',
        }),
        LoadStudentByKeycloakID() {
            eventBus.$emit('student-fetch:started');
            this.FetchStudentByKeycloakID()
                .then(response => {
                    this.student = Object.assign({}, response);
                    eventBus.$emit('student-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('student-fetch:finished'));
        },
        LoadStudentContactDetailsByStudentID() {
            eventBus.$emit('student-contact-details-fetch:started');
            this.FetchStudentContactDetailsByStudentID({ StudentID: this.student.StudentID })
                .then(response => {
                    this.studentContactDetails = Object.assign({}, response);
                    eventBus.$emit('student-contact-details-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('student-contact-details-fetch:finished'));
        },
        LoadCurrentStudentEnrolmentsByStudentID() {
            eventBus.$emit('student-enrolments-fetch:started');
            this.FetchCurrentStudentEnrolmentsByStudentID({ StudentID: this.student.StudentID })
                .then(response => {
                    this.studentEnrolments = [...response];
                    eventBus.$emit('student-enrolments-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('student-enrolments-fetch:finished'));
        }
    },
    computed: {
        DateOfBirthForDisplay() {
            if (this.student == null) {
                return null;
            }

            return moment(this.student.DateOfBirth).format('DD-MM-YYYY');
        }
    }
};